import { GIFT_TABLE_STATUS } from 'constants/giftTableStatus';

export const giftsTablesTransformer = (listOfGiftsTables) => {
  const transformed = listOfGiftsTables
    .map((gift) => ({
      ...gift,
      labels: [
        {
          label: `#Evento ${gift.evento}`,
          weight: 'bold',
        },
        {
          label: `${gift.tipo}`,
          weight: 'bold',
          position: 'left',
        },
      ],
      value: gift.evento,
    }))
    .filter((gift) => gift.estatus === GIFT_TABLE_STATUS.OPEN);

  return transformed;
};
